export const geoPhoneTypeLabel: Record<string, string> = {
    unknown: 'Unknown Location',
    outside: 'Outside Geofence Location',
};